import { useMsal } from "@azure/msal-react";
import {
  CircularProgress,
  Container,
  Grid,
  Typography,
  Paper,
  IconButton,
  Tooltip,
  Divider,
  Button,
} from "@material-ui/core";
import { FilterList, ArrowForward, Close } from "@material-ui/icons";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React, { ReactElement, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { globalStyles } from "../../../assets/globalStyles";
import { useStyles } from "./anomalieStyle";
import ZeitFilter from "../../../features/filter/zeit";
import {
  selectIsChangedZeit,
  resetEndeCounter,
  resetStartCounter,
  resetEndeZeitraum,
  resetStartZeitraum,
  resetStartDatum,
  setEndeCounter,
  setEndeZeitraum,
  setStartCounter,
  setStartDatum,
  setStartZeitraum,
  selectStartDatumTemp,
  setEndeDatum,
  resetEndeDatum,
  selectEndeDatumTemp,
  setIsChangedZeit,
  selectEndeCounterTemp
} from "../../../features/filter/zeitSlice";
import MessstellenFilter from "../../../features/filter/messstellen";
import KenngroesseFilter from "../../../features/filter/kenngroesse";
import {
  getKenngroesse,
  setKenngroesseWert,
  selectKenngroesseWertTemp,
  resetKenngroesseWert,
  selectIsChangedKenngroesse,
  setIsChangedKenngroesse,
} from "../../../features/filter/kenngroesseSlice";
import {
  getMessstellen,
  setMessstelleWert,
  selectMessstelleWertTemp,
  resetMessstelleWert,
  selectIsChangedMessstelle,
  setIsChangedMessstelle,
} from "../../../features/filter/messstellenFilterSlice";
import AnomalieFilter from "./anomalieFilter";
import {
  setAnteilTage,
  resetAnteilTage,
  setAnteilTageWert,
  resetAnteilTageWert,
  setAnomalie,
  resetAnomalie,
  setAnomalieWert,
  resetAnomalieWert,
  setSignifikanz,
  resetSignifikanz,
  setAnomalietyp,
  resetAnomalietyp,
  selectAnomalietypTemp,
  setIsChangedAnomalie,
  selectIsChangedAnomalie,
  selectIsFirstInitLoad,
  selectSignifikanzTemp,
  setIsFirstInitLoad,
  selectAnteilTageWertTemp
} from "./anomalieFilterSlice";
import {
  selectSelectedTab,
  selectSelectedTabVorher,
  setSelectedTab,
  setSelectedTabVorher,
} from "./anomalieSlice";
import {
  getAnomalienGeneral,
  selectAnomalieListe,
  selectIsLoadingGeneralGrid,
} from "./anomalieGeneralGridSlice";
import {
  selectAnomalieDetailedList,
  deleteAnomalieDetailedElem,
  setIsOld,
  selectIsLoadingDetailedGrid,
} from "./anomalieDetailedGridSlice";
import AnomalieDetaliedGrid from "./anomalieDetailedGrid";
import AnomalieGeneralGrid from "./anomalieGeneralGrid";

function Anomalie(): ReactElement {
  const { instance } = useMsal();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getKenngroesse("anomalien"));
    dispatch(getMessstellen());
  }, [instance]);

  const classes = {
    ...globalStyles(),
    ...useStyles(),
  };

  const isChangedZeit = useAppSelector(selectIsChangedZeit);
  const isChangedKenngroesse = useAppSelector(selectIsChangedKenngroesse);
  const isChangedMessstelle = useAppSelector(selectIsChangedMessstelle);
  const isChangedAnomalien = useAppSelector(selectIsChangedAnomalie);
  const isInitFirstLoad = useAppSelector(selectIsFirstInitLoad);
  const loadingAnomalie = useAppSelector(selectIsLoadingGeneralGrid);
  const anomalieGeneralObject = useAppSelector(selectAnomalieListe);

  const kenngroesse = useAppSelector(selectKenngroesseWertTemp);
  const messstelle = useAppSelector(selectMessstelleWertTemp);
  const startDate = useAppSelector(selectStartDatumTemp);
  const endeDate = useAppSelector(selectEndeDatumTemp);
  const anomalietypen = useAppSelector(selectAnomalietypTemp);
  const signifikanz = useAppSelector(selectSignifikanzTemp);
  const anteilTage = useAppSelector(selectAnteilTageWertTemp);
  const endDate = useAppSelector(selectEndeCounterTemp);

  const selectedTab = useAppSelector(selectSelectedTab);
  const selectedTabVorher = useAppSelector(selectSelectedTabVorher);

  const anomalieDetailedTables = useAppSelector(selectAnomalieDetailedList);
  const isLoadingDetailedGrid = useAppSelector(selectIsLoadingDetailedGrid);

  const [selectedTabFilter, setSelectedTabFilter] = React.useState("zeit");
  const [filter, openFilter] = React.useState(true);

  function closeTab(tab: string, listLength: number) {
    if (listLength == 1) {
      dispatch(setSelectedTab("generalGrid"));
    } else if (selectedTab == tab) {
      dispatch(setSelectedTab(selectedTabVorher));
    }
  }

  return (
    <div>
      <Container maxWidth={false} style={{ marginTop: "10px" }}>
        <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }}>
          <Grid item md={3} />
          <Grid item md={6}>
            <Typography color="primary" variant="h5">
              Anomalie
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <Paper
        className={classes.paper}
        style={{
          marginLeft: "24px",
          marginRight: "24px",
          marginBottom: "10px",
        }}
      >
        <form
          className={classes.root}
          noValidate
          autoComplete="off"
          style={{ marginBottom: "10px" }}
        >
          <div>
            <Grid container spacing={4} style={{ marginBottom: "10px" }}>
              <Grid container item md={12} style={{ paddingLeft: "16px" }}>
              <Grid container item xs={12} >
                  <Grid item xs={11} ></Grid>
                    {filter ? 
                  <Grid item xs={1} style={{ textAlign: "end" }}>
                    <IconButton onClick={() => openFilter(false)}>
                      <Tooltip title="Filter zuklappen">
                        <ArrowForward />
                      </Tooltip>
                    </IconButton> 
                  </Grid> 
                    : 
                  <Grid item xs={1} style={{ textAlign: "end"}}>
                      <IconButton onClick={() => openFilter(true)}>
                    <Tooltip title="Filter aufklappen">
                      <FilterList />
                    </Tooltip>
                  </IconButton>
                  </Grid>
                   } 
                </Grid>
                <Grid item md={filter ? 7 : 12}>
                  <Tabs
                    value={selectedTab}
                    onChange={(event, value) => {
                      dispatch(setSelectedTab(value));
                      dispatch(setSelectedTabVorher(selectedTab));
                    }}
                    indicatorColor="secondary"
                    textColor="secondary"
                    TabIndicatorProps={{
                      style: {
                        height: "5px",
                      },
                    }}
                  >
                    <Tab
                      fullWidth={true}
                      label="Anomalien Übersicht"
                      value="generalGrid"
                      style={{ marginRight: "15px" }}
                    ></Tab>
                    {anomalieDetailedTables.map((el) => (

                      <Tab
                        fullWidth={true}
                        style={{
                          minWidth: "max-content",
                          marginRight: "15px",
                          color: el.isOld ? "red" : "",
                        }}
                        key={el.kenngroesseKurzname + el.messstelle}
                        value={el.kenngroesseKurzname + el.messstelle}
                        label={
                          <Grid container>
                            <Grid container item md={12}>
                              <Grid item style={{ alignSelf: "center" }}>
                                <Typography style={{ fontSize: "14px" }}>
                                  {el.kenngroesseKurzname + " " + el.messstelle}
                                </Typography>
                              </Grid>
                              <Grid item style={{ textAlignLast: "right" }}>
                                <Button
                                  component={"div"}
                                  key={el.kenngroesseKurzname + el.messstelle}
                                  onClick={(e: React.MouseEvent) => {

                                    e.stopPropagation();
                                    dispatch(deleteAnomalieDetailedElem(el));
                                    closeTab(
                                      el.kenngroesseKurzname + el.messstelle,
                                      anomalieDetailedTables.length
                                    );
                                  }}
                                  style={{
                                    minWidth: "unset",
                                    color: "rgb(177, 177, 177)",
                                  }}
                                >
                                  <Close />
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        }
                      ></Tab>
                    ))}
                  </Tabs>
                  {isLoadingDetailedGrid ? (
                    <CircularProgress
                      size="30px"
                      style={{ marginTop: "100px", padding: "1px" }}
                    />
                  ) : (
                    anomalieDetailedTables.map((el) =>
                      selectedTab == el.kenngroesseKurzname + el.messstelle ? (
                        <Grid
                          container
                          item
                          md={12}
                          style={{ paddingTop: "20px" }}
                        >
                          {el.anomalieDetailedObject.length == 0 ? (
                            <Typography> Keine Daten vorhanden. </Typography>
                          ) : (
                            <AnomalieDetaliedGrid
                              anomalieDetailedObjectProp={
                                el.anomalieDetailedObject
                              }
                            />
                          )}
                        </Grid>
                      ) : (
                        ""
                      )
                    )
                  )}
                  {selectedTab == "generalGrid" ? (
                    loadingAnomalie ? (
                      <CircularProgress
                        size="30px"
                        style={{ marginTop: "100px", padding: "1px" }}
                      />
                    ) : anomalieGeneralObject.length > 0 ? (
                      <Grid
                        container
                        item
                        md={12}
                        style={{ paddingTop: "20px" }}
                      >
                        <AnomalieGeneralGrid />
                      </Grid>
                    ) : (
                      <React.Fragment>
                        <Grid
                          item
                          md={12}
                          style={{
                            textAlign: "left",
                            marginRight: "20px",
                            marginLeft: "50px",
                            paddingTop: "100px",
                          }}
                        >
                          <div style={{ height: "30vh" }}>
                            {anomalieGeneralObject.length == 0 &&
                              !isInitFirstLoad ? (
                              <Typography>Keine Daten vorhanden.</Typography>
                            ) : (
                              <Typography>
                                Bitte Filter definieren, um Anomalien
                                anzuzeigen. Bestätigen Sie den Filter über
                                anwenden.
                              </Typography>
                            )}
                          </div>
                        </Grid>
                      </React.Fragment>
                    )
                  ) : (
                    ""
                  )}
                </Grid>
                {filter ? (
                  <React.Fragment>
                    <Grid item md={5} style={{ paddingLeft: "16px" }}>
                      <Grid
                        container
                        md={12}
                        style={{
                          paddingTop: "5px",
                          paddingBottom: "24px",
                          paddingRight: "24px",
                          justifyContent: "end",
                        }}
                      >
                        <Grid
                          container
                          md={1}
                          style={{
                            margin: "0px",
                            width: "10px",
                            maxWidth: "20px",
                            padding: "0px",
                          }}
                        >
                          <Divider orientation="vertical" flexItem />
                        </Grid>
                        <Grid item container md={11}>
                          <Grid item md={12}>
                            <Tabs
                              value={selectedTabFilter}
                              onChange={(event, value) =>
                                setSelectedTabFilter(value)
                              }
                              indicatorColor="secondary"
                              textColor="secondary"
                              TabIndicatorProps={{
                                style: {
                                  height: "5px",
                                },
                              }}
                            >
                              <Tab label="Zeit" value="zeit" />
                              <Tab label={"Messstelle ("+ messstelle.length +")"} value="messstelle" />
                              <Tab label={"Kenngröße ("+ kenngroesse.length +")"} value="kenngroesse" />
                              <Tab label="Anomalie" value="anomalie" />
                            </Tabs>
                            {selectedTabFilter == "zeit" ? <ZeitFilter /> : ""}
                            {selectedTabFilter == "messstelle" ? (
                              <MessstellenFilter name={"anomalien"} />
                            ) : (
                              ""
                            )}
                            {selectedTabFilter == "kenngroesse" ? (
                              <KenngroesseFilter name={"anomalien"} />
                            ) : (
                              ""
                            )}
                            {selectedTabFilter == "anomalie" ? (
                              <AnomalieFilter />
                            ) : (
                              ""
                            )}
                            <Grid
                              container
                              md={12}
                              style={{ marginTop: "30px" }}
                            >
                              <Grid item container md={6} />
                              <Grid
                                item
                                container
                                md={6}
                                style={{ justifyContent: "end" }}
                              >
                                <Button
                                  style={{ width: "45%" }}
                                  variant="contained"
                                  onClick={() => {
                                    dispatch(resetKenngroesseWert());
                                    dispatch(resetMessstelleWert());
                                    dispatch(resetEndeCounter());
                                    dispatch(resetStartCounter());
                                    dispatch(resetEndeZeitraum());
                                    dispatch(resetStartZeitraum());
                                    dispatch(resetStartDatum());
                                    dispatch(resetEndeDatum());
                                    dispatch(resetAnomalie());
                                    dispatch(resetAnteilTage());
                                    dispatch(resetAnteilTageWert());
                                    dispatch(resetSignifikanz());
                                    dispatch(resetAnomalietyp());
                                    dispatch(resetAnomalieWert());
                                    dispatch(setIsChangedMessstelle(false));
                                    dispatch(setIsChangedKenngroesse(false));
                                    dispatch(setIsChangedZeit(false));
                                    dispatch(setIsChangedAnomalie(false));
                                    dispatch(setIsOld(true));
                                  }}
                                  color="default"
                                  className={classes.showDuoButton}
                                  disabled={
                                    !isChangedZeit &&
                                    !isChangedKenngroesse &&
                                    !isChangedMessstelle &&
                                    !isChangedAnomalien
                                  }
                                >
                                  Rückgängig
                                </Button>
                                <Button
                                  style={{ width: "45%" }}
                                  variant="contained"
                                  onClick={() => {
                                    dispatch(setKenngroesseWert());
                                    dispatch(setMessstelleWert());
                                    dispatch(setEndeZeitraum());
                                    dispatch(setEndeCounter());
                                    dispatch(setStartZeitraum());
                                    dispatch(setStartCounter());
                                    dispatch(setStartDatum());
                                    dispatch(setEndeDatum());
                                    dispatch(setAnomalie());
                                    dispatch(setAnteilTage());
                                    dispatch(setAnteilTageWert());
                                    dispatch(setSignifikanz());
                                    dispatch(setAnomalietyp());
                                    dispatch(setAnomalieWert());
                                    dispatch(setIsChangedMessstelle(false));
                                    dispatch(setIsChangedKenngroesse(false));
                                    dispatch(setIsChangedZeit(false));
                                    dispatch(setIsChangedAnomalie(false));
                                    dispatch(
                                      getAnomalienGeneral(
                                        messstelle,
                                        kenngroesse,
                                        startDate,
                                        endeDate,
                                        anomalietypen,
                                        signifikanz
                                      )
                                    );
                                    dispatch(setIsOld(true));
                                    dispatch(setIsFirstInitLoad(false));
                                  }}
                                  color="secondary"
                                  className={classes.showDuoButton}
                                  disabled={
                                  //   (!isChangedZeit &&
                                  //     !isChangedKenngroesse &&
                                  //     !isChangedMessstelle &&
                                  //     !isChangedAnomalien ) 
                                  // || 
                                    (kenngroesse.length == 0 ||
                                      messstelle.length == 0) ||
                                    (startDate === endeDate) ||
                                    signifikanz.length == 0 ||
                                    anomalietypen.length == 0 ||
                                    anteilTage < 0 || endDate == 0

                                  }
                                >
                                  Anwenden
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </React.Fragment>
                ) : ""
                }
              </Grid>
            </Grid>
          </div>
        </form>
      </Paper>
    </div>
  );
}

export default Anomalie;
